'use client';

import Script from 'next/script';
import { usePathname } from 'next/navigation';

export function GoogleAdSense() {
    const pathname = usePathname();
    const isAdminRoute =
        pathname === "/admin" ||
        pathname.startsWith("/admin/") ||
        pathname === "/admin-dashboard" ||
        pathname.startsWith("/admin-dashboard/");

    if (isAdminRoute) {
        return null;
    }

    return (
        <>
            <Script
                src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-4704600108238951"
                strategy="lazyOnload"
            />

            {/* Google Analytics (GA4) */}
            <Script
                src={`https://www.googletagmanager.com/gtag/js?id=${process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID}`}
                strategy="lazyOnload"
            />
            <Script
                id="google-analytics"
                strategy="lazyOnload"
                dangerouslySetInnerHTML={{
                    __html: `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '${process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID}', {
              page_path: window.location.pathname,
            });
          `,
                }}
            />
        </>
    );
}
